import type { FC } from 'react';
import type React from 'react';
import { memo, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';

import { isBrowser } from '../utils/web';

interface Props extends React.HTMLAttributes<HTMLElement> {
  selector: string;
}

export const Portal: FC<Props> = memo(function Portal({ selector, children }) {
  const [mounted, setMounted] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    ref.current = document.querySelector(selector);
    setMounted(true);
    return () => setMounted(false);
  }, [selector]);

  return isBrowser && mounted && ref.current ? ReactDOM.createPortal(children, ref.current) : null;
});
